import { Box, Grid } from '@material-ui/core'
import numeral from 'numeral'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { animateScroll } from 'react-scroll'

import {
  customerToken,
  customerTokenCallback,
  customerUpdate,
  errorNotice,
  getComuni,
  getDefaultFinancements,
  getNazioni,
  getOrdine,
  getProductDetails,
  newComuni,
  newDefaultFinancements,
  newDefaultFinancementsv4,
  newNazioni,
  newOrdine,
  newProductDetails,
  phaseChange,
  postNewOrdine,
  pricingUpdate,
  putTracciato,
  putTracciatoCallback,
  reroute,
  storeDumpItForce,
  updateFinancements,
} from '../../../actions/Buy'
import {
  compassCalcolatriceLogistica,
  getTabelleDominioCompass,
  getTabelleDominioCompassCallbackCittadinanza,
} from '../../../actions/buy/Compass'
import {
  getLogisticaCentriConvenzionati,
  setCompassCalcolatriceLogistica,
  setLogisticaCentroConvenzionato,
  setLogisticaCodiceProvincia,
} from '../../../actions/buy/Logistica'
import {
  getOrdiniCodicePreventivo,
  setCodicePreventivo,
} from '../../../actions/buy/Ordini'
import { postLastStepVisitedLead } from '../../../actions/common/Step'
import { enhancedEcommerceTracker } from '../../../tracking/EnhancedEcommerce/tracker'
import isDisponibile from '../../../utils/disponibilitaUtils'
import Coupon from '../../Input/Coupon'
import CouponHelperModal from '../../noleggia/dumb/CouponHelperModal'
import {
  CRITEO_EVENTS,
  EVENT_TYPES,
  triggerClickStreamEvent,
} from '../../triggerDataLayerEvent'
import BuyButton from '../dumb/BuyButton'
import BuyCartRow from '../dumb/BuyCartRow'
import BuyPricePromozione from '../dumb/BuyPricePromozione'
import BuyPricePromozioneVertical from '../dumb/BuyPricePromozioneVertical'
import BuyRadioInput from '../dumb/BuyRadioInput'
import BuySelectInput2 from '../dumb/BuySelectInput2'
import {
  getNextRoute,
  haGaranzia3Anni,
  isFindomestic,
  preparaValoriLogistica,
} from '../utils'

class Cart extends Component {
  constructor(props) {
    super(props)
    this.state = {
      legge104show: !!props.customer.agevolazione_iva_104,
      agevolazione_iva_104_error: '',
      privacy_agevolazioni_fiscali_error: '',
      showCodicePreventivo: false,
      codicePreventivo: props.ordine.codice_preventivo,
      isEECTracked: false,
      isPreventivoValidated: false,
      is104Validated: true,
      centriConvenzionati: [],
      show_coupon_helper_modal: false,
    }
    this.state.toTop = false
    this.state.modal = false
    this.getPriceForCriteo = this.getPriceForCriteo.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleLogisticaSelected = this.handleLogisticaSelected.bind(this)
    this.handleProvinciaLogisticaSelected =
      this.handleProvinciaLogisticaSelected.bind(this)
    this.isLogististicaDisabled = this.isLogististicaDisabled.bind(this)
    this.getSelectedLogistica = this.getSelectedLogistica.bind(this)
    this.handleCodicePreventivo = this.handleCodicePreventivo.bind(this)
    this.getInitialData = this.getInitialData.bind(this)
    this.canSubmit = this.canSubmit.bind(this)
    this.isAutoDisponibile = this.isAutoDisponibile.bind(this)
    this.computeTotalWithTransport = this.computeTotalWithTransport.bind(this)
  }

  componentWillMount() {
    if (
      !('email' in this.props.customer) ||
      this.props.customer.email === null ||
      this.props.customer.email.length === 0
    ) {
      this.props.reroute('/register')
    }
  }

  componentDidMount() {
    this.props.phaseChange({ phase: 10 })
    this.props.pricingUpdate({
      total: this.props.product.prezzo_sellout + this.doOwnershipPricing(),
    })
    if (!this.state.toTop) {
      animateScroll.scrollToTop() // this.setState({ toTop: true })
    }

    if (
      !('comune' in this.props.comuni) ||
      this.props.comuni.comune === null ||
      this.props.comuni.comune.length === 0
    ) {
      this.props
        .getComuni({
          uri: `${window.brumbrum.url_api}/comuni/p/v1/list/comune`,
          method: 'GET',
          callback: this.props.newComuni,
        })
        .catch(() => null)
    }

    if (
      !('nazione' in this.props.comuni) ||
      this.props.comuni.nazione === null ||
      this.props.comuni.nazione.length === 0
    ) {
      this.props
        .getNazioni({
          uri: `${window.brumbrum.url_api}/comuni/p/v1/list/nazioni/complete/all`,
          method: 'GET',
          callback: this.props.newNazioni,
        })
        .catch(() => null)
    }

    /**
     * BRUM-808
     * PROCESSO D'ACQUISTO: organizzazione integrazione opzioni di consegna/logistica nel frontend
     */
    if (
      !this.props.logistica.centro_convenzionato ||
      (this.props.logistica.centro_convenzionato &&
        !this.props.logistica.centro_convenzionato.nome_provincia)
    ) {
      this.props.getLogisticaCentriConvenzionati().catch(() => null)
    }

    if (this.state.codicePreventivo) {
      this.handleCodicePreventivo()()
    }

    this.props.postLastStepVisitedLead().catch(() => null)

    if (!this.state.isEECTracked) {
      this.setState(
        {
          isEECTracked: true,
        },
        () =>
          enhancedEcommerceTracker
            .pushCheckout(
              {
                product: this.props.product,
                ordine: this.props.ordine,
              },
              1
            )
            .then(() => {})
      )
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.logistica &&
      nextProps.logistica.centri_convenzionati_by_provincia &&
      !this.state.centriConvenzionati.length
    ) {
      this.setState({
        centriConvenzionati: Object.keys(
          nextProps.logistica.centri_convenzionati_by_provincia
        ).map(codiceProvincia => {
          const _ = {
            label:
              nextProps.logistica.centri_convenzionati_by_provincia[
                codiceProvincia
              ].label,
            value:
              nextProps.logistica.centri_convenzionati_by_provincia[
                codiceProvincia
              ].value,
          }
          return _
        }),
      })
    }
  }

  getSelectedLogistica(attr) {
    /**
     * se non ho gia' creato un ordine con un centro e' Milano
     * altrimenti e' il centro convenzionato selezionato
     */
    if (this.props.logistica.centro_convenzionato) {
      if (attr === 'codice_provincia') {
        return this.props.logistica[attr]
      }
      return this.props.logistica.centro_convenzionato[attr]
      // eslint-disable-next-line no-else-return
    }
    // ritorno il primo centro convenzionato della lista
    return this.props.logistica.centri_convezionati[
      Object.keys(this.props.logistica.centri_convezionati)[0]
    ][attr]
  }

  autoFullName() {
    const iva104 = this.props.customer.agevolazione_iva_104 ? ' (IVA 4%)' : ''
    return `${this.props.product.marca} ${this.props.product.modello}${iva104}`
  }

  autoPricing() {
    return this.props.product.prezzo_sellout
  }

  promotionAutoPricing() {
    let pricing = this.autoPricing()

    if (this.props.customer.agevolazione_iva_104) {
      pricing = this.autoPricingDiscount104()
    }

    if (this.props.ordine.preventivo_confermato) {
      pricing -= this.props.ordine.sconto
    }

    return pricing
  }

  ownershipPricing() {
    return this.doOwnershipPricing()
  }

  doOwnershipPricing() {
    return this.props.product.passaggio_proprieta_totale_generale
  }

  totale() {
    return this.props.pricing.total
  }

  handleLogisticaSelected() {
    return event => {
      const nomeCentroConvenzionato = event.target.value
      this.props.setLogisticaCentroConvenzionato(
        this.props.logistica.centri_convezionati[nomeCentroConvenzionato]
      )
    }
  }

  handleDeliveryCityDescription(deliveryCity) {
    if (deliveryCity.descrizione_consegna_frontend) {
      return deliveryCity.descrizione_consegna_frontend
    }

    switch (deliveryCity.tipologia_consegna) {
      case 'Ritiro in garage':
      case 'Spedizione':
        return "Raggiungi il centro per il ritiro dell'auto"
      case 'Consegna a casa':
        return 'Un nostro Specialista di Consegna porterà l’auto direttamente all’indirizzo da te scelto'
      default:
        return deliveryCity.tipologia_consegna
    }
  }

  handleProvinciaLogisticaSelected() {
    const _this = this
    return (event, create) => {
      const codice_provincia_logistica = event?.value
      if (codice_provincia_logistica) {
        if (create === true) {
          this.state.centriConvenzionati.push(event)
          this.setState({
            centriConvenzionati: this.state.centriConvenzionati,
            provinciaLogistica: event,
          })
          _this.props.setLogisticaCentroConvenzionato(null)
          // HANDLE UNDEFINED
        } else if (codice_provincia_logistica !== 'NOT_FOUND') {
          _this.props.setLogisticaCodiceProvincia(codice_provincia_logistica)
          this.setState({ provinciaLogistica: event })
          // seleziono il primo centro di consegna per questa provincia
          const nome_centro_consegna =
            _this.props.logistica.centri_convenzionati_by_provincia[
              codice_provincia_logistica
            ].modalita[0].nome
          _this.props.setLogisticaCentroConvenzionato(
            _this.props.logistica.centri_convezionati[nome_centro_consegna]
          )
        } else {
          this.setState({
            provinciaLogistica: event,
          })
          _this.props.setLogisticaCentroConvenzionato(null)
          // HANDLE UNDEFINED
        }
      }
    }
  }

  isLogististicaDisabled() {
    /**
     * se ho un ordine gia' creato
     * non posso variare la logistica
     */
    return !!this.props.ordine.id_ordine
  }

  canSubmit() {
    /**
     * BRUM-8000
     * si puo' procedere con la creazione dell'utente
     * e conseguente invio di mail auth0 se
     * - la validazione del form e' ok (eg. checkbox agevolazioni) e
     * - l'auto e' disponibile o e' stato inserito un codice preventivo valido
     */
    if (this.areAgevolazoniRequired(this.props.customer)) {
      this.handleCheckbox('agevolazione_iva_104')({
        target: { checked: this.props.customer.agevolazione_iva_104 },
      })
      this.handleCheckbox('privacy_agevolazioni_fiscali')({
        target: { checked: this.props.customer.privacy_agevolazioni_fiscali },
      })
      this.setState({
        legge104show: true,
      })
      this.props.errorNotice({ type: 'dati_non_corretti' })
      return false
    }
    if (!this.props.fetching) {
      this.setState({
        is104Validated: true,
      })
      return true
    }

    // default non si puo' inviare
    return false
  }

  getInitialData() {
    const payload = {
      uri: `${window.brumbrum.url_api}/cms/p/v4/auto/${this.props.product.id_auto}`,
      method: 'POST',
      callback: newProductDetails,
    }

    return this.props.getProductDetails(payload)
  }

  isAutoDisponibile() {
    const isDisponibileResult = isDisponibile(this.props.product)
    if (!isDisponibileResult) {
      this.props.errorNotice({ type: 'auto_non_disponibile' })
    }
    return isDisponibileResult
  }

  handleSubmit() {
    const t = this
    if (t.canSubmit() || t.isAutoDisponibile()) {
      t.setState({ modal: true })
      const modalStart = new Date().getTime()
      t.getInitialData().then(json => {
        if (!isDisponibile(json.result) && !t.state.isPreventivoValidated) {
          // mostro errore auto non disponibile
          t.props.errorNotice({ type: 'auto_non_disponibile' })
          t.setState({ modal: false })
        } else {
          const payload = {
            email: this.props.customer.email,
            name: this.props.customer.name,
            surname: this.props.customer.surname,
            phone: this.props.customer.phone,
            id_auto: this.props.product.id_auto,
          }

          const userToken = new Promise((resolve, reject) => {
            if (
              !('token' in this.props.customer) ||
              this.props.customer.token === null ||
              this.props.customer.token.length === 0
            ) {
              t.props
                .customerToken({
                  uri: `${window.brumbrum.url_api}/utenti/p/v1/u/1`,
                  method: 'POST',
                  body: JSON.stringify(payload),
                  callback: t.props.customerTokenCallback,
                  error_400: 'dati_non_corretti',
                })
                .then(() => {
                  if (isFindomestic(t.props.product)) {
                    // findomestic non ha il secci
                    resolve('findomestic non ha tracciati')
                  } else {
                    const copb = t.props.privacy
                      .consenso_obbligatorio_privacy_brumbrum
                      ? 1
                      : 0
                    t.props
                      .putTracciato({
                        method: 'POST',
                        uri: `${window.brumbrum.url_api}/compass/t/v1/tracciati`,
                        token: t.props.customer.token,
                        body: JSON.stringify({
                          consenso_obbligatorio_privacy_brumbrum: copb,
                        }),
                        callback: t.props.putTracciatoCallback,
                      })
                      .then(() => {
                        resolve('user token retrieved + tracciati call done')
                      })
                      .catch(ex => {
                        t.setState({ modal: false })
                        reject(ex)
                      })
                  }
                })
                .catch(ex => {
                  t.setState({ modal: false })
                  reject(ex)
                })
            } else {
              resolve('user token exists')
            }
          })

          Promise.all([userToken]).then(() => {
            if (
              !('id_ordine' in t.props.ordine) ||
              t.props.ordine.id_ordine === null ||
              t.props.ordine.id_ordine.length === 0
            ) {
              const ordiniBody = {
                id_auto: t.props.product.id_auto,
                id_citta_consegna: t.props.logistica.centro_convenzionato.id,
                id_lead: t.props.ordine.id_evento,
              }
              if (isFindomestic(t.props.product)) {
                // findomestic non ha tracciati
              } else {
                ordiniBody.id_tracciato = t.props.privacy.id_tracciato
              }

              if (t.state.codicePreventivo) {
                ordiniBody.codice_preventivo = t.state.codicePreventivo
              }

              // BRUM-
              if (t.props.customer.agevolazione_iva_104) {
                ordiniBody.agevolazione_iva = 1
              }

              t.props
                .postNewOrdine({
                  method: 'post',
                  uri: `${window.brumbrum.url_api}/ordini/t/v1/ordini`,
                  token: t.props.token,
                  body: JSON.stringify(ordiniBody),
                  error_400: 'auto_non_disponibile',
                  callback: t.props.newOrdine,
                })
                .then(() => {
                  // fbPixel(FB_EVENTS.AddToCart, t.props.product);

                  if (
                    t.props.product.rate_finanziamento &&
                    t.props.product.rate_finanziamento.length > 0
                  ) {
                    t.props.updateFinancements({
                      default: t.props.product.rate_finanziamento,
                    })

                    t.props.compassCalcolatriceLogistica(() => {})
                    // aspettare almeno due secondi da modalStart
                    t.executeAfterFrom(modalStart, 2000, () => {
                      t.setState({ modal: false })
                      t.props.phaseChange({
                        last: t.props.ui.last > 10 ? t.props.ui.last : 10,
                      })
                      t.props.reroute(
                        getNextRoute('/checkout', t.props.product)
                      )
                    })
                  } else if (
                    !('default' in t.props.financements) ||
                    t.props.financements.default === null ||
                    t.props.financements.default.length !== 3
                  ) {
                    t.props
                      .getDefaultFinancements({
                        method: 'POST',
                        uri: `${window.brumbrum.url_api}/cms/p/v4/auto/${t.props.product.id_auto}/finanziamento`,
                        callback: t.props.newDefaultFinancementsv4,
                      })
                      .then(() => {
                        t.props.compassCalcolatriceLogistica(() => {})
                        // aspettare almeno due secondi da modalStart
                        t.executeAfterFrom(modalStart, 2000, () => {
                          t.setState({ modal: false })
                          t.props.phaseChange({
                            last: t.props.ui.last > 10 ? t.props.ui.last : 10,
                          })
                          t.props.reroute(
                            getNextRoute('/checkout', t.props.product)
                          )
                        })
                      })
                      .catch(() => {
                        /**
                         * BRUM-1968
                         * fallback su v1
                         */
                        if (!isFindomestic(this.props.product)) {
                          const _path = `/compass/t/v1/calcolatrice/${t.props.ordine.id_ordine}/${t.props.product.id_auto}`
                          t.props
                            .getDefaultFinancements({
                              method: 'POST',
                              uri: `${window.brumbrum.url_api}${_path}`,
                              token: t.props.customer.token,
                              callback: t.props.newDefaultFinancements,
                            })
                            .then(() => {
                              // aspettare almeno due secondi da modalStart
                              t.executeAfterFrom(modalStart, 2000, () => {
                                t.setState({ modal: false })
                                t.props.phaseChange({
                                  last:
                                    t.props.ui.last > 10 ? t.props.ui.last : 10,
                                })
                                t.props.reroute(
                                  getNextRoute('/checkout', t.props.product)
                                )
                              })
                            })
                            .catch(() => {
                              t.setState({ modal: false })
                            })
                        }
                      })
                  } else {
                    t.props.compassCalcolatriceLogistica(() => {})

                    // aspettare almeno due secondi da modalStart
                    t.executeAfterFrom(modalStart, 2000, () => {
                      t.setState({ modal: false })
                      t.props.phaseChange({
                        last: t.props.ui.last > 10 ? t.props.ui.last : 10,
                      })
                      t.props.reroute(
                        getNextRoute('/checkout', t.props.product)
                      )
                    })
                  }
                })
                .catch(() => {
                  t.setState({ modal: false })
                })
            } else {
              t.setState({ modal: true })
              t.props.phaseChange({
                last: t.props.ui.last > 10 ? t.props.ui.last : 10,
              })
              t.props.reroute(getNextRoute('/checkout', t.props.product))
            }

            enhancedEcommerceTracker
              .pushCheckoutOption(
                1,
                t.props.logistica.centro_convenzionato?.nome
              )
              .then(() => {})
          })
        }
      })

      triggerClickStreamEvent(
        CRITEO_EVENTS.BASKET_FUNNEL_SERVICES,
        EVENT_TYPES.CRITEO,
        {
          email: this.props.customer.email,
          idAuto: this.props.product.id_auto,
          price: this.getPriceForCriteo(),
        }
      )
    }
  }

  /**
   *
   * @param from timestamp
   * @param after ms after timestamp
   * @param callback eseguita subito oppure quando after e' passato
   */
  executeAfterFrom(from, after, callback) {
    const now = new Date().getTime()
    const elapsed = now - from
    if (elapsed >= after) {
      // delay gia' superato
      callback()
    } else {
      // aspetto quanto manca
      const remaining = after - elapsed
      setTimeout(callback, remaining)
    }
  }

  legge104Toggle() {
    const t = this
    return event => {
      event.preventDefault()
      t.setState({ legge104show: !t.state.legge104show })
    }
  }

  areAgevolazoniRequired(customer) {
    /**
     * BRUM-1573 le due checkbox sono opzionali
     * ma mutuali
     */
    if (this.props.product.legge_104 === 'Si') {
      return (
        !!customer.agevolazione_iva_104 !==
        !!customer.privacy_agevolazioni_fiscali
      )
    }
    return false
  }

  handleCheckbox(name) {
    const t = this
    return event => {
      const isChecked = !!event.target.checked
      t.props.customerUpdate({
        [name]: isChecked,
      })
      // devo anche aggiornare l'altra
      const other =
        name === 'agevolazione_iva_104'
          ? 'privacy_agevolazioni_fiscali'
          : 'agevolazione_iva_104'
      const otherIsChecked = t.props.customer[other]
      const isRequired = isChecked || otherIsChecked
      const is104Validated = !isRequired || (isChecked && otherIsChecked)
      t.setState({
        [`${name}_error`]: isRequired && !isChecked ? 'is-error' : '',
        [`${other}_error`]: isRequired && !otherIsChecked ? 'is-error' : '',
        is104Validated,
      })
    }
  }

  autoPricingDiscount104() {
    return (Number(this.autoPricing()) / 1.22) * 1.04
  }

  hideCodicePreventivo() {
    const t = this
    return () => {
      t.setState({
        showCodicePreventivo: false,
      })
    }
  }

  showCodicePreventivo() {
    const t = this
    return () => {
      animateScroll.scrollToTop()
      t.setState({
        showCodicePreventivo: true,
      })
    }
  }

  handleInput(inputName) {
    const t = this
    return event => {
      t.setState({
        [inputName]:
          typeof event.target.value === 'string'
            ? event.target.value.trim().toUpperCase()
            : event.target.value,
      })
    }
  }

  handleCoupon() {
    const t = this
    return async coupon => {
      if (coupon.error) {
        t.setState({
          isPreventivoValidated: false,
        })

        return false
      }

      t.props.setCodicePreventivo(coupon.value)

      try {
        const json = await t.props.getOrdiniCodicePreventivo()

        const isPreventivoValidated =
          json.result.id_auto === t.props.product.id_auto

        t.setState({
          legge104show: t.props.customer.agevolazione_iva_104,
          isPreventivoValidated,
        })

        t.setState({ codicePreventivo: coupon.value })
        t.props.setCodicePreventivo(coupon.value)

        return isPreventivoValidated
      } catch (e) {
        /**
         * resetta il codice preventivo per sbloccare l'overlay
         */
        t.setState({
          isPreventivoValidated: false,
        })
        t.props.setCodicePreventivo('')
        t.setState({
          codicePreventivo: '',
        })

        return false
      }
    }
  }

  handleCodicePreventivo() {
    const t = this
    return () => {
      if (!t.state.codicePreventivo) {
        // se codice preventivo e' vuoto
        return
      }
      t.setState({
        showCodicePreventivo: false,
      })
      t.props.setCodicePreventivo(t.state.codicePreventivo)
      t.props
        .getOrdiniCodicePreventivo()
        .then(json => {
          t.setState({
            legge104show: t.props.customer.agevolazione_iva_104,
            isPreventivoValidated:
              json.result.id_auto === t.props.product.id_auto,
          })
        })
        .catch(() => {
          /**
           * resetta il codice preventivo per sbloccare l'overlay
           */
          t.setState({
            isPreventivoValidated: false,
          })
          t.props.setCodicePreventivo('')
          t.setState({
            codicePreventivo: '',
          })
        })
    }
  }

  computeTotalWithTransport(valoriLogistica) {
    if (this.props.customer.agevolazione_iva_104) {
      const scontiServizi = this.props.ordine.totale - this.autoPricing()
      return (
        this.autoPricingDiscount104() +
        scontiServizi +
        valoriLogistica.logisticaRaw.centro_convenzionato.prezzo
      )
    }
    return (
      this.props.ordine.totale +
      valoriLogistica.logisticaRaw.centro_convenzionato.prezzo
    )
  }

  getPriceForCriteo() {
    const { ordine, customer, logistica } = this.props
    const formatString = '$ 0,0[.]00'
    const valoriLogistica = preparaValoriLogistica(this.totale(), logistica)

    let value = valoriLogistica.totalone

    if (ordine.preventivo_confermato) {
      return (value = numeral(
        this.computeTotalWithTransport(valoriLogistica)
      ).format(formatString))
    }

    if (customer.agevolazione_iva_104) {
      return (value = numeral(
        valoriLogistica.totale -
          this.autoPricing() +
          this.autoPricingDiscount104()
      ).format(formatString))
    }

    return value
  }

  render() {
    numeral.language('it')
    numeral.defaultFormat('$ 0,0.00')

    /**
     * BRUM-808 logistica
     */
    const valoriLogistica = preparaValoriLogistica(
      this.totale(),
      this.props.logistica
    )

    const privacyPolicyUrl = '/privacy-policy'
    const informativaDatiParticolari =
      'https://files.brumbrum.it/pdf/informativa-legge104_v15112022.pdf'

    return (
      <div className={''} id="sellout_cart_rows">
        <div className="process__header">
          <h1 className="process__title">Riepilogo del tuo ordine</h1>
          <p className="process__intro"></p>
        </div>
        <div className="user-informations">
          <div className="container_small">
            <div className="the-cart">
              <div className="f-table cart">
                <div className={'section-cart'}>
                  <h5 className={'section-title secondary'}>La tua Auto</h5>
                  <BuyCartRow
                    label={this.autoFullName()}
                    pricePromozione={
                      this.props.ordine.preventivo_confermato ? (
                        <BuyPricePromozione
                          isFreePrice={this.props.ordine.sconto > 0}
                          numberOrText="number"
                          prezzoLogistica={numeral(this.autoPricing()).format()}
                          prezzoLogisticaPromozione={numeral(
                            this.promotionAutoPricing()
                          ).format()}
                          promoLabel="Sconto"
                        />
                      ) : this.props.customer.agevolazione_iva_104 ? (
                        <BuyPricePromozione
                          value={numeral(this.promotionAutoPricing()).format()}
                        />
                      ) : (
                        <BuyPricePromozione
                          value={numeral(this.autoPricing()).format()}
                        />
                      )
                    }
                  />
                  <BuyCartRow
                    label="Passaggio di proprietà"
                    pricePromozione={
                      <BuyPricePromozione
                        value={numeral(this.ownershipPricing()).format()}
                      />
                    }
                  />

                  {/* <BuyCartRow
                    label="Lavaggio ed igienizzazione professionale"
                    pricePromozione={
                      <BuyPricePromozione
                        value="Incluso"
                        valueClassName="free-price"
                      />
                    }
                  /> */}
                  {haGaranzia3Anni(this.props.garanzia) ? (
                    <BuyCartRow
                      label="3 anni di garanzia sui guasti e assistenza stradale"
                      pricePromozione={
                        <BuyPricePromozione
                          value="Inclusa"
                          valueClassName="free-price"
                        />
                      }
                    />
                  ) : null}
                </div>
                <div className={'section-cart'}>
                  <h5
                    className={'section-title --reduced no-transform secondary'}
                  >
                    Consegna della tua auto
                  </h5>
                  {Object.keys(this.props.logistica.centri_convezionati)
                    .length ? (
                    <BuyCartRow
                      extraCss="select-dropdown no-border-bottom"
                      hideRight
                      label="Provincia"
                    >
                      <BuySelectInput2
                        async={false}
                        creatable={false}
                        dataCy="cart-province"
                        defaultValue={this.getSelectedLogistica(
                          'codice_provincia'
                        )}
                        disabled={this.isLogististicaDisabled()}
                        formatCreateLabel={inputValue => inputValue}
                        liClassName={'cart_select_logistica wide'}
                        onCreateOption={inputValue => {
                          this.handleProvinciaLogisticaSelected()(
                            { value: 'NOT_FOUND', label: inputValue },
                            true
                          )
                        }}
                        placeholder={'Seleziona la Provincia'}
                        update={this.handleProvinciaLogisticaSelected()}
                        value={this.state.provinciaLogistica}
                        values={this.state.centriConvenzionati
                          .filter(province => province.label !== null)
                          .sort((a, b) =>
                            (a.label || '').localeCompare(b.label || '')
                          )}
                      />
                    </BuyCartRow>
                  ) : null}

                  {!!Object.keys(this.props.logistica.centri_convezionati)
                    .length &&
                    !!this.props.logistica.codice_provincia &&
                    this.state.provinciaLogistica &&
                    this.state.provinciaLogistica.value !== 'NOT_FOUND' && (
                      <BuyCartRow
                        extraCss="modalita_consegna"
                        hideRight
                        label="Modalità"
                      >
                        <p>Scegli l’opzione più comoda per te</p>
                        <div id={'logistica_modalita_consegna'}>
                          <ul className="data-form active">
                            <BuyRadioInput
                              defaultValue={this.getSelectedLogistica('nome')}
                              disableLastClass
                              disabled={this.isLogististicaDisabled()}
                              label={'modalita di consegna '}
                              liClassName={'modalita_consegna_li'}
                              pricePromozione={
                                <BuyPricePromozioneVertical
                                  {...valoriLogistica}
                                />
                              }
                              spanClass="value small"
                              update={this.handleLogisticaSelected()}
                              values={this.props.logistica.centri_convenzionati_by_provincia[
                                this.props.logistica.codice_provincia
                              ].modalita.map(centro => ({
                                label:
                                  centro.tipologia_consegna_frontend ||
                                  centro.tipologia_consegna,
                                value: centro.nome,
                                description: () =>
                                  this.handleDeliveryCityDescription(centro),
                              }))}
                            />
                          </ul>
                        </div>
                      </BuyCartRow>
                    )}

                  {this.state.provinciaLogistica &&
                    this.state.provinciaLogistica.value === 'NOT_FOUND' && (
                      <BuyCartRow extraCss="modalita_consegna" label="Modalità">
                        <div id={'logistica_modalita_consegna_non_trovata'}>
                          Nella tua città non è ancora presente un centro
                          convenzionato con brumbrum.
                          <br />
                          Sarai contattato dal nostro servizio clienti per
                          concordare la modalità e il luogo più comodi per il
                          ritiro
                        </div>
                      </BuyCartRow>
                    )}
                </div>
              </div>

              <div className="f-table cart acconti">
                <div className={'section-cart section-total'}>
                  <h5
                    className={'section-title --reduced no-transform secondary'}
                  >
                    Dettaglio costi
                  </h5>
                  <BuyCartRow
                    extraCss={`foot gray calculate-total ${
                      this.props.ordine.acconti ? '' : 'last'
                    }`}
                    label={
                      this.props.ordine.acconti ? 'Totale ordine' : 'Totale'
                    }
                    pricePromozione={
                      this.props.ordine.preventivo_confermato ? (
                        <BuyPricePromozione
                          value={numeral(
                            this.computeTotalWithTransport(valoriLogistica)
                          ).format('$ 0,0[.]00')}
                        />
                      ) : this.props.customer.agevolazione_iva_104 ? (
                        <BuyPricePromozione
                          value={numeral(
                            valoriLogistica.totale -
                              this.autoPricing() +
                              this.autoPricingDiscount104()
                          ).format('$ 0,0[.]00')}
                        />
                      ) : (
                        <BuyPricePromozione value={valoriLogistica.totalone} />
                      )
                    }
                  />
                </div>
              </div>
            </div>
          </div>

          {this.props.ordine.acconti ? (
            <div className="f-table cart acconti">
              <BuyCartRow
                extraCss="foot gray calculate-total"
                label="Acconto pre-autorizzato"
                pricePromozione={
                  <BuyPricePromozione
                    value={numeral(this.props.ordine.acconti).format(
                      '$ 0,0[.]00'
                    )}
                  />
                }
              />
            </div>
          ) : null}

          {this.props.ordine.acconti ? (
            <div
              className="f-table cart"
              style={this.props.ordine.acconti ? { marginTop: '-2px' } : {}}
            >
              <BuyCartRow
                extraCss="foot last gray calculate-total"
                label="Totale dovuto"
                pricePromozione={
                  this.props.ordine.preventivo_confermato ? (
                    <BuyPricePromozione
                      value={numeral(
                        this.computeTotalWithTransport(valoriLogistica) -
                          this.props.ordine.acconti
                      ).format('$ 0,0[.]00')}
                    />
                  ) : this.props.customer.agevolazione_iva_104 ? (
                    <BuyPricePromozione
                      value={numeral(
                        valoriLogistica.totale -
                          this.autoPricing() +
                          this.autoPricingDiscount104() -
                          this.props.ordine.acconti
                      ).format('$ 0,0[.]00')}
                    />
                  ) : (
                    <BuyPricePromozione
                      value={numeral(
                        valoriLogistica.totale - this.props.ordine.acconti
                      ).format('$ 0,0[.]00')}
                    />
                  )
                }
              />
            </div>
          ) : null}
        </div>

        {this.props.product.legge_104 === 'Si' ? (
          <div
            style={{
              margin: '20px auto 20px',
              maxWidth: '950px',
              padding: '0 15px',
            }}
          >
            <p className="cta104" style={{ fontSize: '13px' }}>
              <a
                href={'#'}
                id={'agevolazioni-toggle'}
                onClick={this.legge104Toggle()}
              >
                Sono interessato ad usufruire dei benefici fiscali connessi
                all’acquisto di un autoveicolo ai sensi della L. n. 104/1992
              </a>
              {this.state.legge104show ? (
                <a
                  href={'#'}
                  id={'agevolazioni-chiudi'}
                  onClick={this.legge104Toggle()}
                  style={{ color: '#aaa' }}
                >
                  &nbsp;| chiudi
                </a>
              ) : null}
            </p>
            {this.state.legge104show ? (
              <div id={'container-agevolazioni'}>
                <ul className={'data-form'}>
                  <li className={this.state.agevolazione_iva_104_error}>
                    <label className="r-checkbox list">
                      <input
                        defaultChecked={
                          this.props.customer.agevolazione_iva_104
                        }
                        disabled={this.isLogististicaDisabled()}
                        name="agevolazione_iva_104"
                        onChange={this.handleCheckbox('agevolazione_iva_104')}
                        type="checkbox"
                        value="0"
                      />
                      <span className="check"></span>
                      Agevolazione IVA al 4%
                    </label>
                  </li>
                  <li className={this.state.privacy_agevolazioni_fiscali_error}>
                    <label className="r-checkbox list long">
                      <input
                        defaultChecked={
                          this.props.customer.privacy_agevolazioni_fiscali
                        }
                        disabled={this.isLogististicaDisabled()}
                        name="privacy_agevolazioni_fiscali"
                        onChange={this.handleCheckbox(
                          'privacy_agevolazioni_fiscali'
                        )}
                        type="checkbox"
                        value="0"
                      />
                      <span className="check"></span>
                      Dichiaro di poter usufruire dei benefici fiscali poichè ho
                      già provveduto a prendere contatto con il Servizio Clienti
                      (02.800.29) prima dell'acquisto per la verifica preventiva
                      della documentazione medica necessaria, altrimenti la
                      proposta contrattuale non potrà essere accettata.
                      Visualizza la{' '}
                      <a
                        href={privacyPolicyUrl}
                        rel="noreferrer"
                        target="_blank"
                      >
                        Privacy Policy
                      </a>{' '}
                      e la{' '}
                      <a
                        href={informativaDatiParticolari}
                        rel="noreferrer"
                        target="_blank"
                      >
                        Informativa dati particolari
                      </a>
                    </label>
                  </li>
                </ul>
              </div>
            ) : null}
          </div>
        ) : null}

        {this.state.is104Validated &&
        (this.state.isPreventivoValidated ||
          (isDisponibile(this.props.product) &&
            !this.state.codicePreventivo)) ? (
          <div className={'buttons_set center no-brd more-pd'}>
            <BuyButton
              classes={`btn btn-primary ${
                this.props.fetching ||
                (!this.isLogististicaDisabled() &&
                  !this.state.provinciaLogistica)
                  ? ' btn-disabled'
                  : ''
              }`}
              dataCy={'cart-submit'}
              label={"Prosegui con l'ordine"}
              update={
                this.props.fetching ||
                (!this.isLogististicaDisabled() &&
                  !this.state.provinciaLogistica)
                  ? () => {}
                  : this.handleSubmit
              }
            />
          </div>
        ) : (
          <div className={'buttons_set center no-brd more-pd'}>
            <BuyButton
              classes={'btn btn-primary btn-disabled'}
              disabled
              label={
                !isDisponibile(this.props.product) &&
                !this.state.codicePreventivo
                  ? 'Auto non disponibile'
                  : !this.state.is104Validated
                  ? 'Completa sezione L. n. 104/1992'
                  : !this.state.isPreventivoValidated
                  ? 'Codice preventivo non valido'
                  : 'Abbiamo rilevato un problema, contatta il servizio clienti'
              }
              update={() => {}}
            />
          </div>
        )}

        <hr className={'cart-separator'} />
        <Box m={2}>
          <Grid
            alignItems="center"
            container
            direction="column"
            justify="center"
            spacing={1}
          >
            <Grid container item justify="center" spacing={1}>
              <Grid item>
                <span
                  style={{
                    fontSize: '14px',
                    fontWeight: 'bold',
                    letterSpacing: '0.1px',
                    wordSpacing: '-1px',
                  }}
                >
                  Codice coupon o promozionale
                </span>
              </Grid>
              <Grid item>
                <a
                  className="help-link"
                  onClick={e => {
                    e.preventDefault()
                    this.setState({ show_coupon_helper_modal: true })
                  }}
                >
                  Hai bisogno di aiuto?
                </a>
              </Grid>
            </Grid>
            <div className="space-20"></div>
            <Grid container item lg={3} md={5} sm={6} xs={12}>
              <Coupon
                label={'Applica'}
                maxCoupons={1}
                name={'coupon'}
                onCouponSubmitted={this.handleCoupon()}
                selloutSettings={this.props.ui.sellout_settings_acquista}
                starterCoupon={this.props.ordine.codice_preventivo}
              />
            </Grid>
          </Grid>
        </Box>
        {/* <div className="space-50"></div> */}
        {/* <div
          className="text-center"
          style={{ marginBottom: "10px", marginTop: "20px" }}
        >
          {!this.props.ordine.codice_preventivo ? (
            <a onClick={this.showCodicePreventivo()}>
              Hai un codice preventivo/prenotazione?
            </a>
          ) : null}
          {!!this.props.ordine.codice_preventivo && (
            <p>
              Codice preventivo/prenotazione{" "}
              {this.props.ordine.codice_preventivo} <b>confermato</b>.
              <br/>
              <a onClick={this.showCodicePreventivo()}>Modifica codice</a>
            </p>
          )}
        </div> */}

        {/* <div
          id={"codicePreventivoWrapper"}
          className={`${
            this.state.showCodicePreventivo
              ? "show-codice-preventivo"
              : "hide-codice-preventivo"
          }`}
        >
          <div className="banner-codice-preventivo">
            <a onClick={this.hideCodicePreventivo()} className="close-cross">
              <span className="icons icons-times"></span>
            </a>

            <b className="mini-title">
              Hai un codice preventivo/prenotazione o un coupon?
            </b>
            <p>
              Inserisci qui il codice che hai ricevuto e clicca OK per
              visualizzare i dettagli del tuo ordine aggiornati
            </p>
            <div className="space-20"></div>
            <BuyTextInput
              type={"text"}
              label={""}
              placeholder={"Scrivi il Codice preventivo"}
              classes="input-data form-input big"
              update={() => null}
              onInput={this.handleInput("codicePreventivo")}
              defaultValue={""}
            />
            <div className="space-50"></div>
            <BuyButton
              label={"OK"}
              update={this.handleCodicePreventivo()}
              classes={`btn btn-primary${
                !this.state.codicePreventivo ? " btn-disabled" : ""
              }`}
            />
          </div>
        </div> */}
        <CouponHelperModal
          content={
            <div>
              <p>
                Per usufruire delle iniziative promozionali e di sconti puoi
                inserire nel campo il codice che hai ricevuto tramite email.
              </p>
              <p>
                Hai ricevuto dal nostro Servizio Clienti un codice o un coupon
                personali? Inserisci nel campo il codice che ti è stato fornito
                durante la telefonata e/o via email.
              </p>
              <p>
                Dopo aver inserito il codice, seleziona il pulsante per
                applicare la tua promozione. Visualizzerai subito i dettagli del
                tuo ordine aggiornati.
              </p>
            </div>
          }
          display={this.state.show_coupon_helper_modal}
          onClose={() => {
            this.setState({ show_coupon_helper_modal: false })
          }}
        />
      </div>
    )
  }
}

Cart.defaultProps = {
  logistica: {},
  customer: {},
  product: {},
  comuni: {},
}

Cart.propTypes = {
  logistica: PropTypes.object,
  customer: PropTypes.object,
  pricing: PropTypes.object,
  product: PropTypes.object,
  fetching: PropTypes.bool,
  comuni: PropTypes.object,
  ordine: PropTypes.object,
  reroute: PropTypes.func,
  phaseChange: PropTypes.func,
  postLastStepVisitedLead: PropTypes.func,
  pricingUpdate: PropTypes.func,
  getComuni: PropTypes.func,
  newComuni: PropTypes.func,
  getNazioni: PropTypes.func,
  newNazioni: PropTypes.func,
  customerUpdate: PropTypes.func,
  errorNotice: PropTypes.func,
  getLogisticaCentriConvenzionati: PropTypes.func,
  setLogisticaCentroConvenzionato: PropTypes.func,
}

const mapStateToProps = state => ({
  pricing: state.pricing,
  token: state.customer.token,
  privacy: state.privacy,
  product: state.product,
  customer: state.customer,
  ordine: state.ordine,
  financements: state.financements,
  comuni: state.comuni,
  fetching: state.ui.fetching,
  compass_tabelledominio: state.compass_tabelledominio,
  ui: state.ui,
  logistica: state.logistica,
  garanzia: state.garanzia,
})

const mapDispatchToProps = dispatch => ({
  pricingUpdate: payload => dispatch(pricingUpdate(payload)),
  phaseChange: payload => dispatch(phaseChange(payload)),
  compassCalcolatriceLogistica: callback =>
    dispatch(compassCalcolatriceLogistica(callback)),
  customerToken: payload => dispatch(customerToken(payload)),
  customerTokenCallback: payload => dispatch(customerTokenCallback(payload)),
  customerUpdate: payload => dispatch(customerUpdate(payload)),
  putTracciato: payload => dispatch(putTracciato(payload)),
  putTracciatoCallback: payload => dispatch(putTracciatoCallback(payload)),
  postLastStepVisitedLead: () => dispatch(postLastStepVisitedLead),
  reroute: payload => dispatch(reroute(payload)),
  postNewOrdine: payload => dispatch(postNewOrdine(payload)),
  updateFinancements: payload => dispatch(updateFinancements(payload)),
  getDefaultFinancements: payload => dispatch(getDefaultFinancements(payload)),
  newDefaultFinancements: payload => dispatch(newDefaultFinancements(payload)),
  newDefaultFinancementsv4: payload =>
    dispatch(newDefaultFinancementsv4(payload)),
  newOrdine: payload => dispatch(newOrdine(payload)),
  getOrdine: payload => dispatch(getOrdine(payload)),
  getComuni: payload => dispatch(getComuni(payload)),
  newComuni: payload => dispatch(newComuni(payload)),
  getNazioni: payload => dispatch(getNazioni(payload)),
  newNazioni: payload => dispatch(newNazioni(payload)),
  getTabelleDominioCompass: payload =>
    dispatch(getTabelleDominioCompass(payload)),
  // eslint-disable-next-line max-len
  getTabelleDominioCompassCallbackCittadinanza: payload =>
    dispatch(getTabelleDominioCompassCallbackCittadinanza(payload)),
  getLogisticaCentriConvenzionati: payload =>
    dispatch(getLogisticaCentriConvenzionati(payload)),
  setLogisticaCentroConvenzionato: payload =>
    dispatch(setLogisticaCentroConvenzionato(payload)),
  setLogisticaCodiceProvincia: payload =>
    dispatch(setLogisticaCodiceProvincia(payload)),
  setCompassCalcolatriceLogistica: payload =>
    dispatch(setCompassCalcolatriceLogistica(payload)),
  storeDumpItForce: payload => dispatch(storeDumpItForce(payload)),
  errorNotice: payload => dispatch(errorNotice(payload)),
  setCodicePreventivo: payload => dispatch(setCodicePreventivo(payload)),
  getOrdiniCodicePreventivo: () => dispatch(getOrdiniCodicePreventivo),
  getProductDetails: payload => dispatch(getProductDetails(payload)),
  newProductDetails: payload => dispatch(newProductDetails(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Cart)
